import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
import { zustandPersistStorage } from '../appState/zustandPersistStorage';
import { normalizeTagId } from '../utils/tagAllocation';

type RawScanState = {
  rawScans: number;
  uniqueTags: string[];
  tagHitCount: Record<string, number>;
  ingestRawTag: (tagId: string) => void;
  clear: () => void;
};

const STORAGE_KEY = 'rfid-raw-scan-draft-v1';

export const useRawScanStore = create<RawScanState>()(
  persist(
    (set) => ({
      rawScans: 0,
      uniqueTags: [],
      tagHitCount: {},

      ingestRawTag: (tagId) => {
        const t = normalizeTagId(tagId);
        if (!t) return;
        set((s) => {
          const tagHitCount = { ...s.tagHitCount, [t]: (s.tagHitCount[t] ?? 0) + 1 };
          const uniqueTags = s.tagHitCount[t] ? s.uniqueTags : [t, ...s.uniqueTags];
          return {
            rawScans: s.rawScans + 1,
            uniqueTags,
            tagHitCount,
          };
        });
      },

      clear: () => set({ rawScans: 0, uniqueTags: [], tagHitCount: {} }),
    }),
    {
      name: STORAGE_KEY,
      storage: createJSONStorage(() => zustandPersistStorage),
      partialize: (s) => ({
        rawScans: s.rawScans,
        uniqueTags: s.uniqueTags,
        tagHitCount: s.tagHitCount,
      }),
    }
  )
);
